import Accordion from "@/components/base/Accordion";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { dentistFaqs } from "@/mocks/dentists";

export default function DentistFaq() {
  return (
    <section className="bg-background-100 py-20 md:py-28">
      <div className="shell">
        <Reveal>
          <SectionHeading
            eyebrow="Diş Hekimleri İçin SSS"
            title="Klinik tarafından en sık sorulanlar"
            description="Klinik iş birliği, rapor teslimi ve formatlar hakkında en çok merak edilenler."
          />
        </Reveal>

        <Reveal>
          <div className="mx-auto mt-14 max-w-3xl">
            <Accordion items={dentistFaqs} />
          </div>
        </Reveal>
      </div>
    </section>
  );
}